const VAS_PREMIUM = 'Premium'
const VAS_VIP = 'VIP'
const VAS_TURBO = 'Turbo'
const VAS_BUMPUP = 'Bumpup'
export {VAS_PREMIUM,VAS_VIP,VAS_TURBO,VAS_BUMPUP}